import { render } from "./WarrantyDetailsGrid.vue?vue&type=template&id=2567cd42"
import script from "./WarrantyDetailsGrid.vue?vue&type=script&lang=js"
export * from "./WarrantyDetailsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__